module.exports = __webpack_public_path__ + "img/tuijianchapin.636aa5ac.png";